'use client';
import { cn } from '@baseball-near-you/ui';
import type { Hero as IHero } from '@bb/sanity.types';
import { SanityLinkButton } from '../../SanityButton';
import { SanityImageComponent } from '../../SanityImageComponent';
import { HeroSearchForm } from './HeroSearchForm';

export function Hero({ block, i }: { block: IHero; i: number }) {
  return (
    <div
      className={cn(
        'relative h-[calc(100vh-5rem)] w-[100vw] border text-center md:h-[calc(100vh-5rem)]',
        i === 0 && '-mt-4'
      )}
      style={{
        backgroundColor: block.image
          ? undefined
          : (block.Color?.hex ?? '#E72425'),
      }}
    >
      <div className="absolute z-[-1] h-full w-full">
        <SanityImageComponent
          value={block.image}
          fill={{ objectFit: 'cover' }}
          priority
          style={{
            filter: 'blur(4px)',
          }}
        />
      </div>
      <div className="z-10 mx-1 flex h-full flex-col items-center justify-start pt-[10%] sm:justify-center sm:pt-0">
        <h1 className="title rounded-sm text-5xl! text-center! text-white sm:mb-4 sm:text-6xl!">
          {block.title}
        </h1>
        {!!block.subtitle && (
          <h3 className="rounded-sm bg-gray-500/25 pt-1 pr-2 pl-1.5 text-white md:text-2xl!">
            {block.subtitle}
          </h3>
        )}
        <div className="mt-4 flex w-full justify-center md:mt-10">
          {block.showSearchBar ? (
            <HeroSearchForm />
          ) : block.button ? (
            <div className="max-w-md">
              <SanityLinkButton button={block.button} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
